import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Pencil, Trash2, Plus } from 'lucide-react';
import { FaToggleOff, FaToggleOn } from "react-icons/fa";
import { useSelector } from 'react-redux';
import axios from 'axios';
import './services.css';
import { Base_Url } from '../config';

const ServicesPage = () => {
  const navigate = useNavigate();
  const [allHowToCards, setAllHowToCards] = useState([]);
  const [toggle, setToggle] = useState(false);
  
  const statecsc = useSelector((state) => state.statecsc);
  const userfromwebmaster = useSelector((state) => state.user);
  
  const isAuthorized = userfromwebmaster.userExists || statecsc.userState === 0;

  const fetchCardsContent = async () => {
    try {
      const response = await axios.get(`${Base_Url}/howto`);
      setAllHowToCards(response.data);
    } catch (err) {
      console.error('Failed to fetch routes:', err);
      setAllHowToCards([]);
    }
  };

  const deleteCard = async (id) => {
    try {
      await axios.delete(`${Base_Url}/howto/${id}`);
      fetchCardsContent();
    } catch (err) {
      console.error('Failed to delete card:', err);
    }
  };

  useEffect(() => {
    fetchCardsContent();
  }, []);

  const ActionButtons = ({ service }) => {
    if (!isAuthorized) return null;

    return (
      <div className="flex justify-center gap-4 mt-3">
        <button
          onClick={(e) => {
            e.preventDefault();
            navigate(`/edit-howto/${service.id}`);
          }}
          className="p-1.5 bg-blue-500 rounded-full hover:bg-blue-600 transition-colors"
        >
          <Pencil className="w-4 h-4 text-white" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            deleteCard(service.id);
          }}
          className="p-1.5 bg-red-500 rounded-full hover:bg-red-600 transition-colors"
        >
          <Trash2 className="w-4 h-4 text-white" />
        </button>
      </div>
    );
  };

  const CardView = () => (
    <div className="row g-4 mt-4">
      {allHowToCards?.map((service, index) => (
        <div key={index} className="col-md-6 col-lg-3">
          {service.link ? (
            <a href={service.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
              <ServiceCard service={service} />
            </a>
          ) : (
            <Link to={service.intlink} className="text-decoration-none">
              <ServiceCard service={service} />
            </Link>
          )}
        </div>
      ))}
    </div>
  );

  const ServiceCard = ({ service }) => (
    <div className="service-card cursor-pointer" role="button" tabIndex={0}>
      <div className="bubble-1"></div>
      <div className="bubble-2"></div>
      <div className="bubble-3"></div>
      <div className="card-body text-center">
        <h5 className="card-title">{service.title}</h5>
        <ActionButtons service={service} />
      </div>
    </div>
  );

  const ListView = () => (
    <table className="table table-striped mt-5">
      <thead>
        <tr>
          <th>No.</th>
          <th>Title</th>
          {isAuthorized && <th>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {allHowToCards?.map((service, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>
              {service.link ? (
                <a href={service.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                  {service.title}
                </a>
              ) : (
                <Link to={service.intlink} className="text-decoration-none">
                  {service.title}
                </Link>
              )}
            </td>
            {isAuthorized && (
              <td>
                <ActionButtons service={service} />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="services-section">
      <div className="container">
        <h2 className="page-title">
          HOW TO @ <span className="highlight-title">CSC</span>
          <span className="ms-3">
            {toggle ? (
              <FaToggleOn
                onClick={() => setToggle(false)}
                color="green"
                style={{ fontSize: "42px" }}
              />
            ) : (
              <FaToggleOff
                onClick={() => setToggle(true)}
                color="gray"
                style={{ fontSize: "42px" }}
              />
            )}
          </span>
        </h2>
        
        <div className="d-flex align-items-center justify-content-center gap-3">
          <h3 className="highlights-heading mb-0">HIGHLIGHTS</h3>
          {isAuthorized && (
            <button
              className="p-1.5 bg-green-500 rounded-full hover:bg-green-600 transition-colors"
              onClick={() => navigate('/add-howto')}
            >
              <Plus className="w-5 h-5 text-white" />
            </button>
          )}
        </div>

        {toggle ? <CardView /> : <ListView />}
      </div>
    </div>
  );
};

export default ServicesPage;